export default __webpack_public_path__ + "static/media/news-7.be84477e.jpg";